<script>

	import axios from 'axios'
	import { required, email } from 'vuelidate/lib/validators'
	import Form from '@/components/Form'
	import Fragment from '@/components/Fragment'

	export default {
		name: 'ContactForm',
		data () {
			return {
				success: true,
				loading: false,
				contactRequest: {
					first_name: null,
					last_name: null,
					company: null,
					city: null,
					state: null,
					country: 'US',
					email: null,
					phone: null,
					description: null
				}
			}
		},

		methods: {
			async submitContactRequest (form) {
				await axios.post(`/api/v1/contact`, form.formData)
			}
		},

		computed: {
			schema () {
				return {
					first_name: { required },
					last_name: { required },
					company: { required },
					city: { required },
					state: { required },
					country: { required },
					email: { required, email },
					phone: { required },
					description: { required }
				}
			}
		},

		render () {
			const root = window.location.origin
			return (
				<Form action={`https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00DC0000000QGV0`} schema={this.schema} formData={this.contactRequest} onSubmit={this.submitContactRequest}>
					{({ success }) => (
						(success || this.$route.query.form === 'thankyou') ? (
							<div class="thankyou">
								<h2>Thank you</h2>
								<p>We have received your contact request and will get back to you shortly.</p>
							</div>
						) : (
							<Fragment>
								<legend>Questions, Comments or More Info? Contact Us.</legend>
								<input type="hidden" name="oid" value="00DC0000000QGV0" />
								<input type="hidden" name="retURL" value={`${root}/contact?form=thankyou`} />
								<div class="form__group">
									<Form.Input
										prop="first_name"
										label="First Name"
									/>
									<Form.Input
										prop="last_name"
										label="Last Name"
									/>
								</div>
								<div class="form__group">
									<Form.Input
										prop="company"
										label="School/Company"
									/>
									<Form.Input
										prop="city"
										label="City"
									/>
								</div>
								<div class="form__group">
									<Form.Select.Countries
										prop="country"
										label="Country"
									/>
									{this.contactRequest.country === 'US' ? (
										<Form.Select.USStates
											prop="state"
											label="State"
										/>
									) : (
										<Form.Input
											prop="state"
											label="Province"
										/>
									)}
								</div>
								<div class="form__group">
									<Form.Input
										prop="email"
										label="Email"
									/>
									<Form.Input
										prop="phone"
										label="Phone"
									/>
								</div>
								<Form.Input
									prop="description"
									label="Message"
									input={(props) => (
										<textarea
											name="message"
											id="message"
											onInput={props.onInputHandler}
											value={props.v.$model}
											attrs={props.$attrs}
										/>
									)}
								/>
							</Fragment>
						)
					)}
				</Form>
			)
		}
	}

</script>


// WEBPACK FOOTER //
// src/components/ContactForm.vue